// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dsum{margin-top:30px}.dsum h3{font-style:normal;font-size:16px;line-height:24px;display:flex;align-items:center;letter-spacing:.02em;text-transform:uppercase}.dsum h3,.dsum ul{font-weight:400;color:#1d1d1b}.dsum ul{margin-top:20px;max-width:40em;padding:0;overflow-x:hidden;list-style:none;font-size:14px;line-height:20px}.dsum ul span:first-child{padding-right:.33em;background:#fff}.dsum ul span+span{float:right;padding-left:.33em;background:#fff}", ""]);
// Exports
module.exports = exports;
